import StatisticsTable from './StatisticsTable'
import OrderStatisticsTable from './OrderStatisticsTable'
import OrderHistoryTable from './OrderHistoryTable'
import BalanceHistoryTable from './BalanceHistoryTable'
import InvoiceHistoryTable from './InvoiceHistoryTable'

Vue.component(StatisticsTable.name, StatisticsTable)
Vue.component(OrderStatisticsTable.name, OrderStatisticsTable)
Vue.component(OrderHistoryTable.name, OrderHistoryTable)
Vue.component(BalanceHistoryTable.name, BalanceHistoryTable)
Vue.component(InvoiceHistoryTable.name, InvoiceHistoryTable)



// WEBPACK FOOTER //
// ./src/js/components/Tables/index.js